import { getToken } from '@/scripts/token.js';
import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getPromptAxios() {
    const token = await getToken();
    if (token === null) {
        throw 'Authorization token was not detected';
    }

    return {
        method: 'GET',
        url: `${process.env.VUE_APP_BACKEND_URL}${constants.URL.PROMPT_GET}`,
        headers: {
            Authorization: token,
            'Cache-Control': 'no-cache',
        },
    };
}

export async function getPrompt() {
    const response = await axiosRequest({
        url: constants.URL.PROMPT_GET,
        method: METHOD.GET,
        requestName: 'GET PROMPT',
        isLoader: false,
    });

    return response == null ? [] : response;
}

export async function getImageDescription(imagePath, promptID) {
    const response = await axiosRequest({
        url: constants.URL.CHAT_GET_IMAGE_DESCRIPTION,
        method: METHOD.GET,
        requestName: 'GET IMAGE DESCRIPTION',
        isLoader: false,
        params: {
            image_path: imagePath,
            prompt_id: promptID,
        },
    });

    return response == null ? '' : response.content;
}

export async function classifyImage(imagePath, assetTypeId, promptId) {
    // Full image enrichment — the SAME classification the backend runs on GUP
    // upload. Returns { filter_item_ids, tags_ids, additional_tags } or null.
    const response = await axiosRequest({
        url: constants.URL.IMAGE_CLASSIFICATION,
        method: METHOD.POST,
        requestName: 'CLASSIFY IMAGE',
        isLoader: false,
        data: {
            image_path: imagePath,
            asset_type_id: assetTypeId,
            prompt_id: promptId,
        },
    });

    if (response == null) {
        console.error('[classifyImage] no response (enrichment failed)', { imagePath, assetTypeId });
        return null;
    }
    return response;
}

export async function createPrompt(data) {
    const response = await axiosRequest({
        url: constants.URL.PROMPT_CREATE,
        method: METHOD.POST,
        requestName: 'CREATE PROMPT',
        data: data,
    });

    return response;
}

export async function updatePrompt(data) {
    const response = await axiosRequest({
        url: constants.URL.PROMPT_UPDATE,
        method: METHOD.PATCH,
        requestName: 'UPDATE PROMPT',
        data: data,
    });

    return response == null ? false : true;
}

export async function deletePrompt(id) {
    const response = await axiosRequest({
        url: constants.URL.PROMPT_DELETE,
        method: METHOD.DELETE,
        requestName: 'DELETE PROMPT',
        params: {
            prompt_id: id,
        },
    });

    return response == null ? false : true;
}
